export default "__VITE_ASSET__ZNJu7Q8T__"